import script from "./Products.vue?vue&type=script&setup=true&lang=js"
export * from "./Products.vue?vue&type=script&setup=true&lang=js"

import "./Products.vue?vue&type=style&index=0&id=7509fab7&scoped=true&lang=css"
import "./Products.vue?vue&type=style&index=1&id=7509fab7&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7509fab7"]])

export default __exports__